import { render } from "./IndicatorsBlock.vue?vue&type=template&id=9f3c4350&scoped=true"
const script = {}

import "./IndicatorsBlock.vue?vue&type=style&index=0&id=9f3c4350&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3c4350"]])

export default __exports__